<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="info" style="background-color: #02b0db">
      <b-navbar-brand to="/">{{$t('system.resident_portal')}}</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>

          <b-nav-item to="/wifi" :active="$router.currentRoute.path == '/wifi'">
            <font-awesome-icon :icon="['fas', 'wifi']"></font-awesome-icon>
            {{$t('system.wifi')}}/{{$t('system.internet_access')}}
          </b-nav-item>
          <b-nav-item to="/faq" :active="$router.currentRoute.path == '/faq'"><font-awesome-icon :icon="['far', 'question-circle']"></font-awesome-icon> {{$t('system.faq')}}</b-nav-item>
          <b-nav-item :active="$router.currentRoute.path == '/my_dorm/tutors'" v-if="$store.state.user != null && $store.state.user.user.bewohner != null && (($store.state.dorm && $store.state.dorm.enable_sv) || $store.state.admin)" to="/my_dorm/tutors">{{ $tc("system.tutor", 2) }}</b-nav-item>
          <b-nav-item :active="$router.currentRoute.path.startsWith('/my_dorm/common_rooms')" v-if="$store.state.user != null && $store.state.user.user.bewohner != null && (($store.state.dorm && $store.state.dorm.enable_common_rooms) || $store.state.admin)" to="/my_dorm/common_rooms">{{ $tc("system.common_rooms", 2) }}</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right v-if="$store.state.admin">
            <template v-slot:button-content>
              Admin
            </template>
            <b-dropdown-item to="/admin/tenants">{{ $tc('system.generate_activation') }}</b-dropdown-item>
            <b-dropdown-item to="/admin/tutors">{{ $tc('system.tutor_admin') }}</b-dropdown-item>
            <b-dropdown-item to="/admin/semester">{{ $tc('system.semester_admin') }}</b-dropdown-item>
            <b-dropdown-item target="_blank" href="/doc/handbuch_stuwe.pdf">Handbuch</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <font-awesome-icon icon="language"></font-awesome-icon>
              Lang
            </template>
            <b-dropdown-item :active="$i18n.locale == 'en'" @click="$i18n.locale = 'en'">EN</b-dropdown-item>
            <b-dropdown-item :active="$i18n.locale == 'de'" @click="$i18n.locale = 'de'">DE</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item to="/login" v-if="$store.state.user == null">
            <font-awesome-icon :icon="['far', 'user']"></font-awesome-icon>
            {{ $tc('system.login') }}
          </b-nav-item>
          <b-nav-item-dropdown right v-else :toggle-class="$route.path.startsWith('/account')?'active':''">
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <font-awesome-icon :icon="['far', 'user']"></font-awesome-icon>
              {{ $store.state.user.user.username }}
            </template>
            <b-dropdown-item to="/account" :active="$router.currentRoute.path== '/account'">{{ $tc('system.account') }}</b-dropdown-item>
            <b-dropdown-item v-if="$store.state.dorm && ($store.state.dorm.enable_mpsk || $store.state.admin)" to="/account/mpsk" :active="$router.currentRoute.path== '/account/mpsk'">{{ $tc('system.mpsk') }}</b-dropdown-item>
            <b-dropdown-item to="/account/cards"  v-if="$store.state.dorm && ($store.state.dorm.enable_common_rooms || $store.state.admin)" :active="$router.currentRoute.path== '/account/cards'">{{ $tc('system.cards') }}</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="logout">{{ $tc('system.logout') }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-container style="margin-top: 10px">
      <b-alert v-for="a in alerts" variant="warning" :key="a.title.en + a.description.en" show>
	<b>{{a.title[$i18n.locale]}}</b><p v-html="a.description[$i18n.locale]"/>
      </b-alert>
      <router-view @alert="handleEvent" />
    </b-container>
    <hr/>
    <div class="" style="width: 100%"><b-link to="/imprint">{{$t('system.imprint')}}</b-link> | <b-link to="/privacy">{{$t('system.privacy_policy')}}</b-link></div>
  </div>
</template>

<script>

import LoginService from '@/api-services/login.service'
import DormService from '@/api-services/dorm.service'
import {EventBus} from '@/eventbus';

export default {
  name: 'App',
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      alertMessage: null,
      alertVariant: null,
      alerts: []
    }
  },
  async mounted() {
    let self = this
    EventBus.$on('alert', (payload) => {
      console.log('Event received')
      self.handleEvent(payload)
    })
    if (this.$store.state.user != null) {
      let resp = await DormService.getMyDorm()
      this.$store.commit('set_dorm', resp.data.dorm)
    }
    this.alerts = (await DormService.getAlerts()).data
  },
  methods: {
    handleEvent(payload) {
      this.alertMessage = payload.message
      if (typeof payload.message === 'object' && 'response' in payload.message && typeof payload.message.response.data === 'object' && 'error' in payload.message.response.data) {
        this.alertMessage = payload.message.response.data.error
      }
      this.alertVariant = payload.variant
      this.dismissCountDown = this.dismissSecs
      this.$bvToast.toast(`${this.$t(this.alertMessage)}`, {
          variant: this.alertVariant,
          title: 'Portal',
          autoHideDelay: 5000,
          appendToast: true
        })
      window.console.debug("Global EV: " + payload)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    logout: function (ev) {
      ev.preventDefault()
      let self = this
      LoginService.logout().then(() => {
        self.$store.commit('logout')
        self.$router.push('/')
      })
    }
  }
}
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';

.container {
  width: 90% !important;
  max-width: 100vw !important;
}
</style>
